import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const TRACTORTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TractorType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const TRACTORTYPE_CONFIG = {
  entityName: 'TractorType',
  localizationKey: 'General::Entity.TractorType',
  fields: TRACTORTYPE_FIELDS,
  permission: 'GeneralMachinesAndVehicles.TractorTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
